import {createActions} from 'client/framework';

const normalActions = ['RECONFIGURE_SCOPE_SELECTOR'];

export default createActions(null, normalActions);
